import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ImageGenerated from '../components/image-generated'
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom'
import { post } from '../config/api';
import { createFirestore, doubleQueryFirestore } from "../config/firestore";
import * as htmlToImage from 'html-to-image';
import './daily-phrase.css'

const DailyPhrase = ({user}) => {

  const location = useLocation();
  const [photoUrl, setPhotoUrl] = useState('');
  const [emotion, setEmotion] = useState('');
  const [phrase, setPhrase] = useState('');
  const [image, setImage] = useState('');
  const [create, setCreate] = useState(false);

  useEffect(()=>{
    const findCreated = async ()=>{
      const response = await doubleQueryFirestore('userEmotion', 'month',  location.state.month, 'day',  location.state.day, user.uid)
      if (response && response.docs[0]) {
        const data = response.docs[0].data()
        if(data){
          setPhrase(data.phrase);
          setImage(data.image);
          setEmotion(data.emotion);
          setPhotoUrl(data.photoUrl);
        }
      }
      else {
        setCreate(true)
        setEmotion(location.state.emotion);
        setPhotoUrl(location.state.photoUrl);
      };
    }
    if (!create) findCreated()

    const getPhrase = async () =>{
      const formData = new FormData();
      formData.append('emotion', emotion)
      const {data} = await post('https://hackathon-2uvycjffja-uc.a.run.app/generateText', 
        formData, { "headers": { 
        "Authorization": `Bearer ${user.accessToken}` },
        "Access-Control-Allow-Origin": "*"
      })
      if (data) setPhrase(data.success);
    }

    if(create && !phrase) getPhrase();

    const getImage = async() =>{
      const formData = new FormData();
      formData.append('emotion', emotion)
      formData.append('phrase', phrase);
      try{
        const {data} = await post('https://hackathon-2uvycjffja-uc.a.run.app/generateImage', 
        formData, { "headers": { 
          "Authorization": `Bearer ${user.accessToken}` ,
          "Access-Control-Allow-Origin": "*" },
          "responseType":"blob"
        });
        console.log(data);
        const fileReader = new FileReader();
        if (data) {
          fileReader.readAsDataURL(data); 
          fileReader.onload = () => setImage(fileReader.result);
        }
      }
      catch{
        fetch('https://hackathon-generative.web.app/playground_assets/dc05119b-27cb-4792-9a19-b7e0e551688d-0-1500w.png')
        .then(res => res.blob()) // Gets the response and returns it as a blob
        .then(blob => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(blob)
          fileReader.onload = () => setImage(fileReader.result);
        });
      }
    }
    if (create && phrase && !image) getImage()

    const createDocument = async ()=>{
      const userEmotionDetails = {
        user: user.uid,
        phrase, 
        photoUrl: photoUrl,
        image,
        emotion: emotion, 
        day: location.state.day,
        month: location.state.month
      }
      const response = await createFirestore('userEmotion', userEmotionDetails)
    }
    if(create && phrase && image) createDocument();
  },[create, emotion, phrase, image]);


  const handleShare = async () => {
    if(navigator.share){
      const picture = await htmlToImage.toBlob(document.getElementById('generated'));
      const file = new File([picture], 'image.jpg', { type: picture.type });
      if(picture) {
        await navigator.share({
          files: [file], 
          text: phrase, 
          title: 'Fruitful Life'
        })
      }
    }
    else{
      alert('Sharing not supported by this browser')
    }
  }

  return (
    <div className="daily-phrase-container" id="generated">
      <Helmet>
        <title>Daily-Phrase - Hackathon</title>
        <meta property="og:title" content="Daily-Phrase - Hackathon" />
      </Helmet>
      <ImageGenerated 
        rootClassName="image-generated-root-class-name"
        heading={phrase}
        image_background={image}
        emotion={emotion}
        photoUrl={photoUrl}
      />
      <div className="daily-phrase-container1">
        <button className="button daily-phrase-button" onClick={handleShare}>Share</button>
        <Link to="/calendar" className="nav-navlink" >
          <button className="button daily-phrase-button1">Log</button>
        </Link>
      </div>
    </div>
  )
}

export default DailyPhrase
